import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) and Amplitude are loaded globally

class ExportButton extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {}
    this.clickExport = this.clickExport.bind(this)
    this.validator = this.props.validator || validatorFactory()
  }

  clickExport(event) {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({ processing: true })
      const params = {}

      if (this.props.startDate && this.props.endDate) {
        params.start_date = this.props.startDate.format(
          this.props.dateFormat || "YYYY-MM-DD"
        )
        params.end_date = this.props.endDate.format(
          this.props.dateFormat || "YYYY-MM-DD"
        )
      }
      if (this.props.multiPropertyExport) {
        params.multi_property_export = this.props.multiPropertyExport
      }
      if (this.props.reportType) {
        params.report_type = this.props.reportType
      }

      this.fireAmplitudeEvent()

      $.post(this.props.url, params, (data) => {
        let url = window.location.href
        if (url.indexOf("?") > -1) {
          url += "&export_enqueued=1"
        } else {
          url += "?export_enqueued=1"
        }
        window.location.href = url
      })
    } else {
      this.forceUpdate()
    }
  }

  fireAmplitudeEvent() {
    Amplitude.trackEvent(`reports:${this.props.amplitudeEvent}`)
  }

  render() {
    return (
      <LegacyButton
        processing={this.state.processing}
        onClick={this.clickExport}
        className={this.props.btnClass || "btn btn-primary"}
        icon={this.props.btnIcon || ""}
        processingText={this.props.btnProcessingText || "Exporting..."}
      >
        {this.props.btnText || "Export"}
      </LegacyButton>
    )
  }
}

ExportButton.propTypes = {
  validator: PropTypes.object,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  dateFormat: PropTypes.string,
  multiPropertyExport: PropTypes.bool,
  reportType: PropTypes.string,
  amplitudeEvent: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  btnClass: PropTypes.string,
  btnIcon: PropTypes.string,
  btnProcessingText: PropTypes.string,
  btnText: PropTypes.string,
}

export default ExportButton
